import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { PageHeader, StatusPill, Section, Loading } from "../components/Common";
import { toast } from "sonner";
import { useAuth } from "../lib/auth";

export default function Notifications() {
  const [items, setItems] = useState(null);
  const { user } = useAuth();
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");

  const load = () => api.notifications().then(({ data }) => setItems(data));

  useEffect(() => { load(); }, []);

  const canSend = ["executive", "principal", "deputy_head", "administrator"].includes(user?.role);

  const submit = async (e) => {
    e.preventDefault();
    if (!title || !body) return;
    try {
      await api.createNotification({ title, body, audience: "all", priority: "normal" });
      setTitle(""); setBody("");
      toast.success("Notice sent");
      load();
    } catch { toast.error("Failed to send"); }
  };

  if (items === null) return <Loading />;
  return (
    <div data-testid="notifications-page">
      <PageHeader kicker="Communications" title="Notifications" subtitle="Whole-school notices scoped to your role." />
      {canSend && (
        <Section title="Send a new notice" testId="send-notice">
          <form onSubmit={submit} className="hl-card p-5 space-y-3 max-w-2xl">
            <input value={title} onChange={(e) => setTitle(e.target.value)} placeholder="Title" className="w-full px-3 py-2 border border-slate-200 rounded-md text-sm" data-testid="notif-title" />
            <textarea value={body} onChange={(e) => setBody(e.target.value)} placeholder="Message" rows={3} className="w-full px-3 py-2 border border-slate-200 rounded-md text-sm" data-testid="notif-body" />
            <button className="hl-btn-primary text-sm" data-testid="notif-send">Send notice</button>
          </form>
        </Section>
      )}
      <Section>
        <div className="space-y-3">
          {items.map((n) => (
            <div key={n.id} className="hl-card p-5" data-testid={`notif-${n.id}`}>
              <div className="flex items-center gap-2 mb-1">
                <StatusPill status={n.priority === "urgent" ? "overdue" : n.priority === "high" ? "warning" : "info"} />
                <span className="text-xs text-slate-500">Audience: {n.audience}</span>
                <span className="ml-auto text-xs text-slate-400">{(n.created_at || "").slice(0, 10)}</span>
              </div>
              <div className="font-display font-bold text-lg tracking-tight">{n.title}</div>
              <div className="text-sm text-slate-600 mt-1">{n.body}</div>
            </div>
          ))}
        </div>
      </Section>
    </div>
  );
}
